document.addEventListener("DOMContentLoaded", function () {
  var elem = document.querySelector(".product-slider");
  if (elem) {
    var flkty = new Flickity(elem, {
      pageDots: false,
      prevNextButtons: true,
      freeScroll: false,
      wrapAround: true,
      contain: true,
      autoPlay: 6000,
      imagesLoaded: true,
      cellAlign: "left",
    });
  }

  var elem = document.querySelector(".customer-feedback-slider");
  if (elem) {
    var isSmallScreen = window.innerWidth < 798;
    var flktyOptions = {
      pageDots: false,
      prevNextButtons: true,
      freeScroll: false,
      wrapAround: true,
      contain: true,
      autoPlay: 4000,
      cellAlign: isSmallScreen ? "left" : "center",
    };

    var flkty = new Flickity(elem, flktyOptions);

    $(window).resize(function () {
      var isSmallScreen = window.innerWidth < 798;
      flkty.options.cellAlign = isSmallScreen ? "left" : "center";
      flkty.update();
    });
  }

  var elem = document.querySelector(".ingredient-slider");
  if (elem) {
    var items = elem.querySelectorAll(".ingredient-item");
    if (items.length > 4) {
      var flkty = new Flickity(elem, {
        pageDots: false,
        prevNextButtons: true,
        freeScroll: false,
        wrapAround: true,
        contain: true,
        autoPlay: 5000,
        imagesLoaded: true,
        cellAlign: "left",
      });
    } else {
      elem.classList.add("ingredient-no-slider");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var section = document.querySelector(".product-form-section");
  if (section) {
    var attr = section.getAttribute("data-smaller-side-sticky");
    if (attr === "true") {
      document.body.classList.add("no-sticky-header");
    }
  }
});

$(".sideProfileBtn").click(function () {
  $(".sideProfileBtn").removeClass("active");
  $('[data-tabid="#subscriptionSec"]').removeClass("active");
  $(this).addClass("active");
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
});

$(".sideProfileBtn-m").click(function () {
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
  $(this).parent().hide();
  $(".account-back-btn").show();
});

if (window.innerWidth <= 767) {
  $(".account-back-btn").click(function () {
    $(".profileSideNav.only-mobile").show();
    $(".tabContentInner").hide();
    $(this).hide();
  });
}

$(document).ready(function () {
  if (
    window.location.pathname.includes("/account/addresses") &&
    window.innerWidth <= 767
  ) {
    $(".profileSideNav.only-mobile").hide();
    $(".account-back-btn").show();
    $("#deliveryAddressSec").show();
  }

  $(window).resize(function () {
    if (
      window.location.pathname.includes("/account/addresses") &&
      window.innerWidth <= 767
    ) {
      $(".profileSideNav.only-mobile").hide();
      $(".account-back-btn").show();
      $("#deliveryAddressSec").show();
    }
  });
});

$(".showNewAddressForm").click(function () {
  $(this).hide();
  $("#add_address").slideDown();
});

$(".cancelAddressForm").click(function () {
  $(".showNewAddressForm").show();
  $("#add_address").slideUp();
});

$(document).ready(function () {
  if (
    window.location.pathname == "/account" &&
    window.location.search.indexOf("pw-page=") != -1
  ) {
    $(".tabContentInner").css("display", "none");
    $(".sideProfileBtn").removeClass("active");
    $('[data-tabid="#subscriptionSec"]').addClass("active");
    $(
      '.profileSideNav.only-mobile [data-tabid="#subscriptionSec"]'
    ).removeClass("active");
    $(".profileSideNav.only-mobile").hide();
    if (window.innerWidth <= 767) {
      $(".account-back-btn").show();
    }
    $("#subscriptionSec").css("display", "block");

    setTimeout(function () {
      var newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }, 5000);
  }
});

$(window).on("resize", function () {
  var windowWidth = $(window).width();

  if (windowWidth < 960) {
    $(".footer__block.block__link-list .footer__heading")
      .off("click")
      .on("click", function () {
        var $Content = $(this).next(".footer__block.block__link-list ul");

        if ($(this).parent().hasClass("footer--active")) {
          $(this).parent().removeClass("footer--active");
          $Content.slideUp();
        } else {
          $(".footer__block.block__link-list ul").slideUp();
          $(".footer__block.block__link-list .footer__menu").removeClass(
            "footer--active"
          );
          $(this).parent().addClass("footer--active");
          $Content.slideDown();
        }
      });
  } else {
    $(".footer__block.block__link-list .footer__heading").off("click");
  }
});

$(window).trigger("resize");

$(document).ready(function () {
  $("li.back-btn").click(function () {
    $("#mobile-submenu-products").trigger("click");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var desktopImages = document.querySelectorAll("#header .header__brand img");
  var desktopImages_2 = document.querySelectorAll(
    ".image-with-text-overlay .image-element__wrap img"
  );

  var mobileImages = document.querySelectorAll(
    "#mobile-header .mobile-logo img"
  );
  var mobileImages_2 = document.querySelectorAll(
    ".image-with-text-overlay .is-hidden-desktop-only img"
  );

  function updateImageLoadingAttributes() {
    if (window.innerWidth > 798) {
      mobileImages.forEach(function (img) {
        img.setAttribute("loading", "lazy");
      });
      mobileImages_2.forEach(function (img) {
        img.setAttribute("loading", "lazy");
      });

      desktopImages.forEach(function (img) {
        img.removeAttribute("loading");
      });
      desktopImages_2.forEach(function (img) {
        img.removeAttribute("loading");
      });
    } else {
      desktopImages.forEach(function (img) {
        img.setAttribute("loading", "lazy");
      });
      desktopImages_2.forEach(function (img) {
        img.setAttribute("loading", "lazy");
      });

      mobileImages.forEach(function (img) {
        img.removeAttribute("loading");
      });
      mobileImages_2.forEach(function (img) {
        img.removeAttribute("loading");
      });
    }
  }

  updateImageLoadingAttributes();

  window.addEventListener("resize", updateImageLoadingAttributes);
});

document.addEventListener("DOMContentLoaded", function () {
  var copyLinkButton = document.getElementById("copy-link-button");
  var copyLinkMessage = document.getElementById("copy-link-message");

  copyLinkButton.addEventListener("click", function () {
    var url = copyLinkButton.getAttribute("data-url");

    var tempInput = document.createElement("input");
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    copyLinkMessage.style.display = "block";

    setTimeout(function () {
      copyLinkMessage.style.display = "none";
    }, 2000); 
  });
});

$(document).ready(function() {
  function updateNumbering(flickityInstance) {
    if (flickityInstance) {
      var slideIndex = flickityInstance.selectedIndex + 1;
      var slideCount = flickityInstance.slides.length;
      $('.carousel-numbering').text(slideIndex + ' of ' + slideCount);
    }
  }

  function initializeFlickity(clickedIndex) {
    var $carousel = $('.ingredient-popup .carousel').flickity({
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      wrapAround: true,
      initialIndex: clickedIndex 
    });

    $carousel.on('select.flickity', function(event, index) {
      updateNumbering($carousel.data('flickity'));
    });

    updateNumbering($carousel.data('flickity'));
  }

  $('.ingredients-gird .content-wrapper .buttons a').on('click', function(event) {
    event.preventDefault();

    $('.ingredient-popup').fadeIn();
    
    var clickedIndex = $(this).data('index'); 
    var slideCount = $('.js-ingredient-popup .slide').length;

    if (slideCount > 1) {
      if ($('.ingredient-popup .carousel').data('flickity')) {
        $('.ingredient-popup .carousel').flickity('destroy');
      }
      initializeFlickity(clickedIndex);
    } else {
      $('.carousel-controls').hide();
    }

    $('html').css('overflow', 'hidden');
  });

  $(document).on('click', '.close', function(event) {
    event.preventDefault();
    $('.ingredient-popup').fadeOut(function() {
      if ($('.ingredient-popup .carousel').data('flickity')) {
        $('.ingredient-popup .carousel').flickity('destroy');
      }
      $('html').css('overflow', ''); 
    });
  });

  $(document).on('click', '.prev-button', function() {
    $('.ingredient-popup .carousel').flickity('previous');
  });

  $(document).on('click', '.next-button', function() {
    $('.ingredient-popup .carousel').flickity('next');
  });
});

$(document).ready(function() {
            $(".oramune-rl a").removeAttr("target");
         });